<template>
    <div>
        <slot :item="item" :imageUrl="imageUrl"></slot>
    </div>
</template>

<script>
import { defineComponent, ref, watch, inject} from 'vue';
import { uniq } from 'lodash';

export default defineComponent({
    name: 'ProgramListingItem',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const item = ref({});
        const imageUrl = inject('imageUrl');

        watch(
            () => props.item,
            (newItem) => {
                item.value = newItem;
            },
            { immediate: true }
        );

        return {
            item: item,
            imageUrl: imageUrl
        }
    }
});

// Make a separate collection-item vue widget that accepts 'item' as props and outputs it back out.
</script>


